import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function OrderSuccess() {

    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout( ( ) => {
            navigate("/")
        }, 3000 )

        return ( ) => clearTimeout(timer)
    }, [navigate]);

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>

            <div className="text-center">

                <div style={{ fontSize: "80px", color: "green" }}>
                    ✅
                </div>

                <h2 className="mt-3">Order Placed Successfully!</h2>

                <p className="text-muted">
                    Thank you for your purchase 🎉
                </p>

                <p className="text-muted">
                    Redirecting to home...
                </p>

            </div>

        </div>
    );
}

export default OrderSuccess;